import React, { useState, useEffect } from 'react';
import { Award } from 'lucide-react';

const animals = [
	{ name: 'Lion', habitat: 'Savanna', continent: 'Africa', image: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/020_The_lion_king_Snyggve_in_the_Serengeti_National_Park_Photo_by_Giles_Laurent.jpg' },
	{ name: 'Giant Panda', habitat: 'Bamboo Forest', continent: 'Asia', image: 'https://images.unsplash.com/photo-1564349683136-77e08dba1ef7?w=800&auto=format&fit=crop' },
	{ name: 'Bald Eagle', habitat: 'Mountains', continent: 'North America', image: 'https://images.unsplash.com/photo-1611689342806-0863700ce1e4?w=800&auto=format&fit=crop' },
	{ name: 'Kangaroo', habitat: 'Grasslands', continent: 'Oceania', image: 'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&auto=format&fit=crop' },
	{ name: 'Jaguar', habitat: 'Rainforest', continent: 'South America', image: 'https://media.snl.no/media/167396/standard_Jaguar__Panthera_onca_palustris__male_Three_Brothers_River_2.jpg' },
	{ name: 'African Elephant', habitat: 'Savanna', continent: 'Africa', image: 'https://images.unsplash.com/photo-1564760055775-d63b17a55c44?w=800&auto=format&fit=crop' },
	{ name: 'Bengal Tiger', habitat: 'Jungle', continent: 'Asia', image: 'https://images.unsplash.com/photo-1561731216-c3a4d99437d5?w=800&auto=format&fit=crop' },
	{ name: 'Grizzly Bear', habitat: 'Forest', continent: 'North America', image: 'https://images.unsplash.com/photo-1589656966895-2f33e7653819?w=800&auto=format&fit=crop' },
	{ name: 'Koala', habitat: 'Eucalyptus Forest', continent: 'Oceania', image: 'https://images.unsplash.com/photo-1459262838948-3e2de6c1ec80?w=800&auto=format&fit=crop' },
	{ name: 'Sloth', habitat: 'Rainforest', continent: 'South America', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT62vz1GYVJ02_ELGXUhtonlM6Woj4Dz-tyA&s' },
	{ name: 'Zebra', habitat: 'Savanna', continent: 'Africa', image: 'https://images.unsplash.com/photo-1501706362039-c06b2d715385?w=800&auto=format&fit=crop' },
	{ name: 'Red Panda', habitat: 'Mountain Forest', continent: 'Asia', image: 'https://images.unsplash.com/photo-1497752531616-c3afd9760a11?w=800&auto=format&fit=crop' },
	{ name: 'Snow Leopard', habitat: 'Mountain', continent: 'Asia', image: 'https://snowleopard.org/wp-content/uploads/2023/10/SnowLeopardTrust_Mongolia-6-e1699471205140.jpg' },
	{ name: 'Polar Bear', habitat: 'Arctic', continent: 'North America', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Polar_Bear_-_Alaska_%28cropped%29.jpg/250px-Polar_Bear_-_Alaska_%28cropped%29.jpg' },
	{ name: 'Chimpanzee', habitat: 'Rainforest', continent: 'Africa', image: 'https://cdn.britannica.com/89/7489-050-D0E7DF35/West-African-chimpanzee-pan-troglodytes.jpg' },
	{ name: 'Emperor Penguin', habitat: 'Antarctic', continent: 'Antarctica', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkt4WwWXMB6hw5bPYHxzNkb3V4BmxLfzspU1CFFsLTjxYEG0kMQlamunI2Tg8TIJOGRmbTbH69OWBMreJiHr8AhSF_9afRrdILVuwsWCU&s=10' },
	{ name: 'Red Fox', habitat: 'Forest', continent: 'Europe', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTycIzjovPO6esnW3MOVVvQyUKV743xYPM0eA&s' },
	{ name: 'Humpback Whale', habitat: 'Ocean', continent: 'Oceania', image: 'https://uk.whales.org/wp-content/uploads/sites/6/2018/06/humpback-whale-vanessa-mignon.jpg' },
	{ name: 'Toucan', habitat: 'Rainforest', continent: 'South America', image: 'https://t4.ftcdn.net/jpg/03/11/22/37/360_F_311223759_2GqmuNTum7xElkCm9lyaw4ZZYqZE2Qlu.jpg' },
	{ name: 'Arctic Fox', habitat: 'Tundra', continent: 'Europe', image: 'https://i.natgeofe.com/k/4cf56024-edd3-4ed7-8a80-d81d90ab78ba/arctic-fox_4x3.jpg' }
];

export default function AnimalGuesserGame() {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [score, setScore] = useState(0);
	const [round, setRound] = useState(1);
	const [gameOver, setGameOver] = useState(false);
	const [selectedAnimal, setSelectedAnimal] = useState(null);
	const [showResult, setShowResult] = useState(false);
	const [isCorrect, setIsCorrect] = useState(false);
	const [usedAnimals, setUsedAnimals] = useState([]);
	const [gameStarted, setGameStarted] = useState(false);  

	useEffect(() => {
		if (gameStarted) shuffleAnimal();
	}, [gameStarted]);

	const shuffleAnimal = () => {
		const available = animals.filter((_, idx) => !usedAnimals.includes(idx));
		if (available.length === 0) {
			setGameOver(true);
			return;
		}
		const randomIndex = animals.indexOf(available[Math.floor(Math.random() * available.length)]);
		setCurrentIndex(randomIndex);
		setUsedAnimals([...usedAnimals, randomIndex]);
	};

	const handleGuess = (animalName) => {
		setSelectedAnimal(animalName);
		const correct = animalName === animals[currentIndex].name;
		setIsCorrect(correct);
		setShowResult(true);

		if (correct) setScore(score + 100);
	};

	const handleNext = () => {
		if (round >= 5) {
			setGameOver(true);
		} else {
			setRound(round + 1);
			setShowResult(false);
			setSelectedAnimal(null);
			shuffleAnimal();
		}
	};

	const restartGame = () => {
		setCurrentIndex(0);
		setScore(0);
		setRound(1);
		setGameOver(false);
		setShowResult(false);
		setSelectedAnimal(null);
		setUsedAnimals([]);
		setGameStarted(true);
	};

	const getOptions = (correct) => {
		const otherNames = animals.map(a => a.name).filter(name => name !== correct);
		const shuffledDistractors = otherNames.sort(() => Math.random() - 0.5).slice(0, 7);
		const options = [...shuffledDistractors, correct];
		return options.sort(() => Math.random() - 0.5);
	};

	// ================= WELCOME PAGE =================
	if (!gameStarted) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-100 via-lime-100 to-green-200 p-4">
			<div className="bg-white p-12 rounded-3xl shadow-2xl text-center border-4 border-amber-200">
			<h1 className="text-5xl font-bold text-green-800 mb-6">Welcome to AnimalGuesser!</h1>
			<p className="text-gray-700 mb-8 text-lg">Can you guess the mystery animal?</p>
			<button
			onClick={() => setGameStarted(true)}
			className="bg-green-500 text-white px-12 py-4 rounded-full font-bold text-xl hover:bg-blue-600 hover:scale-105 transition-all duration-200"
			>
			Play
			</button>
			</div>
			</div>
		);
	}

	// ================= GAME OVER =================
	if (gameOver) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-100 via-lime-100 to-green-200 p-4">
			<div className="bg-white p-8 rounded-3xl shadow-2xl text-center border-4 border-amber-200">
			<Award className="w-20 h-20 mx-auto mb-4 text-yellow-600" />
			<h1 className="text-4xl font-bold mb-4 text-green-800">Great Job!</h1>
			<p className="text-6xl font-bold text-green-600 mb-2">{score}</p>
			<p className="text-gray-700 font-medium mb-4">Total Score</p>
			<button
			onClick={restartGame}
			className="bg-green-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-600 hover:scale-110 transition-all duration-300"
			>
			Play Again
			</button>
			</div>
			</div>
		);
	}

	const options = getOptions(animals[currentIndex].name);

	return (
		<div className="min-h-screen bg-gradient-to-br from-amber-100 via-lime-100 to-green-200 p-4">
		<div className="max-w-6xl mx-auto">
		<div className="bg-white rounded-3xl shadow-lg p-4 mb-4 flex justify-between items-center border-4 border-amber-200">
		<h1 className="text-2xl font-bold text-green-800">AnimalGuesser</h1>
		<div className="flex gap-6">
		<div className="text-center">
		<p className="text-base text-gray-800">Round</p>
		<p className="text-2xl font-bold text-green-600">{round}/5</p>
		</div>
		<div className="text-center">
		<p className="text-base text-gray-600">Score</p>
		<p className="text-2xl font-bold text-amber-600">{score}</p>
		</div>
		</div>
		</div>

		{/* Mystery Animal Image */}
		<div className="relative h-90 w-full bg-gray-200 rounded-xl overflow-hidden mt-5">
		<img
		src={animals[currentIndex].image}
		alt="Mystery Animal"
		className={`w-full h-full object-cover transition-all duration-200 ${!showResult ? 'filter brightness-[0.5] blur-[20px]' : ''}`}
		/>
		{!showResult && (
			<div className="absolute inset-0 flex items-center justify-center text-white text-2xl font-bold">
			Mystery Animal
			</div>
		)}
		</div>

		<div className="p-8">
		{!showResult ? (
			<div className="grid grid-cols-2 md:grid-cols-4 gap-3">
			{options.map(animal => (
				<button
				key={animal}
				onClick={() => handleGuess(animal)}
				className="bg-green-500 text-white py-3 px-4 rounded-2xl font-semibold hover:bg-green-600 hover:scale-105 transition-all duration-300"
				>
				{animal}
				</button>
			))}
			</div>
		) : (
			<div className="text-center">
			{isCorrect ? (
				<div className="mb-6">
				<div className="text-6xl mb-4">🎉</div>
				<h2 className="text-3xl font-bold text-green-600 mb-2">Correct!</h2>
				<p className="text-xl text-green-700 mb-2">+100 points</p>
				</div>
			) : (
				<div className="mb-6">
				<div className="text-6xl mb-4">🤔</div>
				<h2 className="text-3xl font-bold text-amber-600 mb-2">Not quite!</h2>
				<p className="text-gray-700 mb-2">
				You guessed: <span className="font-semibold">{selectedAnimal}</span>
				</p>
				</div>
			)}

			{/* Reveal Normal Image */}
			<div className="bg-gradient-to-r from-lime-50 to-green-50 rounded-2xl p-6 mb-6 border-2 border-lime-300">
			<h3 className="text-2xl font-bold text-green-800 mb-3">{animals[currentIndex].name}</h3>
			<img
			src={animals[currentIndex].image}
			alt={animals[currentIndex].name}
			className="w-full h-64 object-cover rounded-xl mb-4"
			/>
			<div className="text-gray-700 space-y-1">
			<p><span className="font-semibold">Habitat:</span> {animals[currentIndex].habitat}</p>
			<p><span className="font-semibold">Continent:</span> {animals[currentIndex].continent}</p>
			</div>
			</div>

			<button
			onClick={handleNext}
			className="bg-green-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-green-600 hover:scale-110 transition-all duration-300"
			>
			{round >= 5 ? 'See Results' : 'Next Animal →'}
			</button>
			</div>
		)}
		</div>
		</div>
		</div>
	);
}
